export const ORDERS_INFO_GET = "ORDERS_INFO_GET";
export const ASC_DATE_FILTER = "ASC_DATE_FILTER";
export const DESC_DATE_FILTER = "DESC_DATE_FILTER";
export const ASC_NUMBER_FILTER = "ASC_NUMBER_FILTER";
export const DESC_NUMBER_FILTER = "DESC_NUMBER_FILTER";
export const ORDER_STATUS_UPDATE = "ORDER_STATUS_UPDATE";
export const ORDER_LAST_DOCUMENT_SAVE = "ORDER_LAST_DOCUMENT_SAVE";
